<template>
  <FAIcon
    v-if="user?.screen_name_ui_contains_non_ascii"
    icon="code"
    :title="$t('unicode_domain_indicator.tooltip')"
  />
</template>

<script>
const UnicodeDomainIndicator = {
  props: {
    user: Object,
  },
}

export default UnicodeDomainIndicator
</script>
